import { createContext } from 'react'

export type ModelConfidentiality = 'company-confidential' | 'non-company-confidential'

export type ModelDataSecurityContextValue = {
  confidentiality?: ModelConfidentiality
  setConfidentiality: (confidentiality?: ModelConfidentiality) => void
  setModelType: (modelType?: string) => void
}

export const ModelDataSecurityContext = createContext<ModelDataSecurityContextValue | undefined>(undefined)
